module.exports = __webpack_public_path__ + "img/ico_product_quantity_plus.4a4fe763.svg";